/** Synthetic correlation clamp and display precision (plan §0.2). */
export const CORR_CLAMP_LO = -0.85;
export const CORR_CLAMP_HI = 0.95;
export const CORR_PRECISION = 2;

/**
 * Length of the factor-loading vector the synthetic cosine similarity dots over
 * — the same 5 as `SectorParams.f` (plan §0.2 SECP).
 *
 * Declared here rather than inferred from the argument because the demo hard-codes
 * `for (i = 0; i < 5; i++)`: a 3-element vector would silently dot over three
 * terms and still divide by a 5-term norm, producing a plausible, wrong, and
 * completely silent correlation.
 */
export const FACTOR_DIMENSIONS = 5;
